import { useQuery } from '@tanstack/react-query';
import {
  getCrossOrgCost,
  CrossOrgCostResponse,
} from '@/services/admin/get-cross-org-cost';

export const useGetCrossOrgCost = (startDate?: string, endDate?: string) =>
  useQuery<CrossOrgCostResponse>({
    queryKey: ['cross-org-cost', startDate, endDate],
    queryFn: () =>
      getCrossOrgCost({ start_date: startDate, end_date: endDate }),
  });
